module.exports = __webpack_public_path__ + "static/media/Roboto-BlackItalic.14f037f9.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-BlackItalic.woff2
// module id = 543
// module chunks = 0